<template>
    <div id="productSwiper">
        <swiper class="swiper swiper-no-swiping" :options="swiperOption" v-if="productImg.length>0">
            <swiper-slide v-for="item in productImg" :key="item.id">
                <div class="img">
                    <img :src="$imgBaseURL+item.bg_url" alt="">
                </div>
            </swiper-slide>
        </swiper>
    </div>
</template>

<script>
    import {Swiper,SwiperSlide} from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    export default {
        name: "ProductSwiper",
        components:{SwiperSlide,Swiper},
        props:{
            productImg:{
                type:Array,
                default:()=>{
                    return []
                }
            }
        },
        data(){
            return{
                swiperOption:{
                    speed: 500,
                    slidesPerView: 7,
                    centeredSlides: true,
                    spaceBetween: 20,
                    grabCursor: true,
                    loop:true,
                    autoplay:true,
                }
            }
        }
    }
</script>

<style scoped lang="less">
#productSwiper{
    margin-top: 30px;
    .img{
        border: 1px solid #D8D8D8;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 76px;
        background-color: #FFFFFF;
        img{
            width: 100%;
        }
    }
}
</style>
